const topicsData = [
  { label: '免费看片软件', count: 1240 },
  { label: '91免费下载', count: 986 },
  { label: '安卓看片app', count: 875 },
  { label: '苹果看片软件', count: 732 },
  { label: '4K超清播放', count: 651 },
  { label: '追剧必备', count: 598 },
  { label: '离线缓存', count: 543 },
  { label: '视频播放器', count: 487 },
  { label: '手机看片', count: 412 },
  { label: 'PC客户端', count: 356 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">话题标签</h2>
          <p className="mt-2 text-sm text-foreground-500">探索91免费社区最热门的话题与讨论</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href={`#topic-${i}`}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer ${
                i < 3
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : i < 6
                  ? 'bg-accent-50 border-accent-200 text-accent-800 hover:bg-accent-100'
                  : 'bg-secondary-50 border-secondary-200 text-secondary-700 hover:bg-secondary-100'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${
                i < 3 ? 'bg-primary-100 text-primary-600' :
                i < 6 ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}